import React from 'react';
import GenericPropertiesControl from './GenericPropertiesControl';
import { useLandusePropertiesStore } from '../../../store/useGeometryPropertiesStore';

const LandusePropertiesControl = () => {
  const store = useLandusePropertiesStore();
  
  const properties = [
    { key: 'type', label: 'Typ', value: store.type },
    { key: 'landuseType', label: 'Nutzungsart', value: store.landuseType }
  ];

  const handlePropertyUpdate = (key, value) => {
    store.updateProperty(key, value);
  };

  return (
    <GenericPropertiesControl 
      properties={properties}
      onPropertyUpdate={handlePropertyUpdate}
      title="EIGENSCHAFTEN"
    />
  );
};

export default LandusePropertiesControl;